export const AppSettings = {
    'IS_FIREBASE_ENABLED': false,
    'SHOW_START_WIZARD': false,
    'SUBSCRIBE': false,
    'FIREBASE_CONFIG': {
      'apiKey': "AIzaSyCToxRhwWg4OgBEJWKrBmBMv_Fk_IOIgmE",
      'authDomain': "neokoddy-74e28.firebaseapp.com",
      'databaseURL': "https://neokoddy-74e28.firebaseio.com",
      'projectId': "neokoddy-74e28",
      'storageBucket': "neokoddy-74e28.appspot.com",
      'messagingSenderId': "35863772368",
      'appId': "1:35863772368:web:fa04944be0ee887c89f2d5",
      'measurementId': "G-RPTRX8BJJS"
    }
};
